module.exports = __webpack_public_path__ + "img/rmcs_4.bdaa3d15.png";